import { Value } from 'app/types-shared';

export interface ImportCaseUpdateData {
  comments: string;
  importSet: number;
  importFileId: number;
}

export interface ImportFormData {
  importset: Value;
  comments: string;
}

export enum ImportFileStatus {
  notSelected,
  notImported,
  failed,
  completed,
  pending
}
